import React from "react";
import { Box, Button, HStack } from "components/ui";
import { Typography } from "components/ui/Typography";
import { useIsMobile } from "utils/hooks/useIsMobile";
import Seo from "components/general/Seo";
import Container from "components/general/Container";
import { useGetNotificationQuery } from "store/abcoApi";
import { NotificationPage } from "components/notification/NotificationPage";
import SiteListSection from "./SiteListSection";
import { OrdersTabPage } from "components/orders/OrdersTabPage";
import { ArrowRight, Bell, List, MapPin, Settings } from "lucide-react-native";
import { useToken } from "@gluestack-style/react";
import { useRouter } from "expo-router";

export default function DashboardMember() {
	const isMobile = useIsMobile();
	const resolvedPrimaryLight = useToken("colors", "primarylight");
	const router = useRouter();
	return (
		<Box px={16} mt={24} my={isMobile ? 12 : 24}>
			<Seo title="Dashboard | Abconet" description="Get a comprehensive overview of system activity, performance metrics, and key insights." />
			<Container>
				<Box flexDirection="row" alignItems="center" px={16} mt={24} my={isMobile ? 12 : 24}>
					<Typography.H1 weight="bold">My Dashboard</Typography.H1>
				</Box>
				<Box borderRadius={12} bg="$neutral35" my={16}>
					<Box p={24}>
						<SiteListSection />
					</Box>
				</Box>
				<Box borderRadius={12} bg="$neutral35" my={16}>
					<Box p={24}>
						<HStack marginBottom={16} alignItems="center" gap={12}>
							<Bell size={24} color="black" />
							<Typography.H3 weight="bold">Notifications</Typography.H3>
						</HStack>

						<NotificationPage isDashboard showPagination={true} />
						<HStack px={20} ml="auto" mb={24} gap={12}>
							<Button backgroundColor="$basicwhite" variant="outline" borderRadius={8} gap={12} onPress={() => router.push("/notifications")}>
								<Bell color={resolvedPrimaryLight} />
								<Typography color={"$primarylight"}>See all notifications</Typography>
							</Button>
							<Button backgroundColor="$basicwhite" borderRadius={8} variant="outline" gap={12} onPress={() => router.push("/profile/notifications")}>
								<Settings color={resolvedPrimaryLight} />
								<Typography color={"$primarylight"}>Notification settings</Typography>
							</Button>
						</HStack>
					</Box>
				</Box>
				<Box borderRadius={12} bg="$neutral35" my={16}>
					<Box p={24}>
						<HStack justifyContent="space-between">
							<HStack marginBottom={16} alignItems="center" gap={12}>
								<List size={24} color="black" />
								<Typography.H3 weight="bold">Orders</Typography.H3>
							</HStack>
							<Button variant="primary-light" borderRadius={8} gap={12} onPress={() => router.push("/orders")}>
								<Typography color={"$basicwhite"}>See all orders</Typography>
								<ArrowRight size={24} color="white" />
							</Button>
						</HStack>
						<OrdersTabPage isDashboard />
					</Box>
				</Box>
			</Container>

			{/* <Container>
				<Box flexDirection="row" alignItems="center">
					<Typography.H2 weight="bold">My Dashboard</Typography.H2>
				</Box>
				<Box bg="$neutral35">
					<Container>
						<SitesSection />
					</Container>
					<Container>
						<Typography.H3 weight="bold" style={{marginBottom:16}}>Notifications</Typography.H3>
						<NotificationPage showPagination={false}/>
					</Container>
					<Container>
						<Typography.H3 weight="bold" style={{marginBottom:16}}>Orders</Typography.H3>
						<OrdersTabPage showPagination={false}/>
					</Container>
				</Box>
			</Container> */}
		</Box>
	);
}
